import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
const bandi = [{
  id: 1,
  title: 'Bando 1 - Nuove Opere',
  image: 'https://cdn.bandiperchicrea.it/bandi/Nuove%20Opere-min.jpg'
}, {
  id: 2,
  title: 'Bando 2 - Formazione e Promozione culturale nelle scuole',
  image: 'https://cdn.bandiperchicrea.it/bandi/Scuole-min.jpg'
}, {
  id: 3,
  title: 'Bando 3 - Professionalizzazione degli artisti',
  image: 'https://cdn.bandiperchicrea.it/bandi/Professionalizzazione-min.jpg'
}, {
  id: 4,
  title: 'Bando 4 - Live e Promozione nazionale ed internazionale',
  image: 'https://cdn.bandiperchicrea.it/bandi/Live-min.jpg'
}];
export function Bandi() {
  return <div className="space-y-6" data-id="element-527">
      {/* Page Header */}
      <div className="bg-white" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '24px 32px'
    }} data-id="element-528">
        <h1 style={{
        fontSize: '24px',
        fontWeight: 400,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif',
        margin: 0
      }} data-id="element-529">
          Bandi
        </h1>
      </div>

      {/* Bandi Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-530">
        {bandi.map(bando => <div key={bando.id} className="flex flex-col bg-white" style={{
        border: '1px solid #E4E4E4',
        borderRadius: '8px',
        overflow: 'hidden'
      }} data-id="element-531">
            {/* Image */}
            <img src={bando.image} alt={bando.title} className="w-full object-cover" style={{
          height: '210px',
          display: 'block'
        }} data-id="element-532" />

            {/* Content */}
            <div className="flex flex-col flex-1" style={{
          padding: '16px'
        }} data-id="element-533">
              {/* Title */}
              <p style={{
            fontSize: '15px',
            fontWeight: 400,
            color: '#293B54',
            fontFamily: 'Roboto, sans-serif',
            lineHeight: 1.4,
            margin: '0 0 16px 0',
            flexGrow: 1
          }} data-id="element-534">
                {bando.title}
              </p>

              {/* Button */}
              <Link to={`/bandi/${bando.id}`} style={{
            display: 'block'
          }} data-id="element-535">
                <button type="button" className="w-full" style={{
              display: 'block',
              width: '100%',
              padding: '10px 16px',
              backgroundColor: 'transparent',
              border: '1px solid #293B54',
              borderRadius: '9999px',
              color: '#293B54',
              fontSize: '14px',
              fontFamily: 'Roboto Condensed, sans-serif',
              fontWeight: 400,
              cursor: 'pointer',
              textAlign: 'center'
            }} data-id="element-536">
                  Dettaglio del bando
                </button>
              </Link>
            </div>
          </div>)}
      </div>
    </div>;
}